export default __webpack_public_path__ + "static/media/PC_ButtonActive.f4a7867e.svg";